import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import api from "../../../api";
import confirmation from "../../../function/confirmation";

export const FilterViewSelect = ({
  currentFilterView,
  onFilterViewChange,
  type,
}) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)

  const [currentFilterViewName, setCurrentFilterViewName] = useState("")
  const [currentFilterViews, setCurrentFilterViews] = useState([])

  const [refresher, setRefresher] = useState(false)
  const refresh = () => setRefresher(!refresher)

  const [newFilterViewName, setNewFilterViewName] = useState("")
  const onNewFilterViewNameChange = (event) => setNewFilterViewName(event.target.value)

  const onNewFilterViewClick = () => setIsDialogVisible(true)
  const onDialogHide = () => setIsDialogVisible(false)
  const onCurrentFilterViewChange = (event) => {
    const filterViewName = event.target.value
    const filterView = currentFilterViews.find((filterView) => filterView.name === filterViewName)

    if (!filterView) return;

    const payload = [...currentFilterViews]

    payload.forEach((filterView) => {
      if (filterView.type === type) {
        filterView.isActive = filterView.name === filterViewName
      }
    })

    api.post("/users/filters", payload)
      .then(() => {
        setCurrentFilterViewName(filterViewName)
        onFilterViewChange(filterView.filters)
      })
  }

  const onNewFilterViewSave = () => {
    const payload = [...currentFilterViews, {
      name: newFilterViewName,
      isActive: false,
      filters: currentFilterView,
      type,
    }]

    api.post("/users/filters", payload)
      .then(() => {
        setNewFilterViewName("")
        setIsDialogVisible(false)
        refresh()
      })
  }

  const onFilterViewReset = () => {
    const payload = [...currentFilterViews]

    payload.forEach((filterView) => {
      if (filterView.type === type) {
        filterView.isActive = false
      }
    })

    api.post("/users/filters", payload)
      .then(() => {
        setCurrentFilterViewName("")
        onFilterViewChange({})
      })
  }

  const onFilterViewDelete = (filterViewName) => {
    const payload = [...currentFilterViews].filter((filterView) => {
      if (filterView.type === type) {
        return filterView.name !== filterViewName
      }

      return true
    })

    api.post("/users/filters", payload)
      .then(() => {
        refresh()
      })
  }

  const itemTemplate = (option) => (
    <div className="flex align-items-center">
      {option.name}
      <Button
        className="ml-auto p-1 p-button-sm p-button-text p-button-danger"
        icon="pi pi-times"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          confirmation(e.currentTarget, "Opravdu smazat pohled?", () => onFilterViewDelete(option.name))
        }}
      />
    </div>
  )

  useEffect(() => {
    api.get("/users/filters")
      .then(({ data }) => {
        setCurrentFilterViews(data.data || [])
      })
  }, [refresher, type])

  useEffect(() => {
    if (currentFilterViews.length > 0) {
      const activeFilterView = currentFilterViews.find((filterView) =>
        filterView.isActive &&
        filterView.type === type
      )

      if (activeFilterView && !currentFilterViewName) {
        setCurrentFilterViewName(activeFilterView.name)
        onFilterViewChange(activeFilterView.filters)
      }
    }
  }, [currentFilterViews, onFilterViewChange, currentFilterViewName, type])

  return (
    <>
      <Dropdown
        placeholder="Načíst pohled"
        emptyMessage="Žádné uložené pohledy"
        value={currentFilterViewName}
        onChange={onCurrentFilterViewChange}
        options={currentFilterViews.filter((filterView) => filterView.type === type)}
        style={{ lineHeight: "15px", marginLeft: "auto", width: 200, maxWidth: 200 }}
        optionLabel="name"
        optionValue="name"
        itemTemplate={itemTemplate}
      />

      <Button
        className="p-button-outlined ml-1"
        icon="pi pi-save"
        onClick={onNewFilterViewClick}
        tooltip="Uložit nový pohled"
        tooltipOptions={{ position: "bottom" }}
      />

      <Dialog
        header="Uložit nový pohled"
        visible={isDialogVisible}
        onHide={onDialogHide}
        style={{ width: 300 }}
      >
        <div className="pt-1">
          <InputText
            value={newFilterViewName}
            onChange={onNewFilterViewNameChange}
            placeholder="Název"
            style={{ width: "100%" }}
          />
        </div>

        <div className="pt-3 flex">
          <Button
            label="Uložit"
            onClick={onNewFilterViewSave}
            disabled={
              !newFilterViewName ||
              currentFilterViews.some((filter) =>
                filter.name === newFilterViewName &&
                filter.type === type
              )
            }
            className="ml-auto"
          />
        </div>
      </Dialog>

      <Button
        className="p-button-outlined p-button-warning ml-1"
        icon="pi pi-replay"
        onClick={onFilterViewReset}
        tooltip="Zrušit filtry"
        tooltipOptions={{ position: "bottom" }}
      />
    </>
  )
}
